import { render, staticRenderFns } from "./TeacherCountDashboard.vue?vue&type=template&id=0f6c3ef5&scoped=true&"
import script from "./TeacherCountDashboard.vue?vue&type=script&lang=js&"
export * from "./TeacherCountDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c3ef5",
  null
  
)

export default component.exports